import React from "react";
import {
  Card,
  Item,
  Button,
  CardActions,
  Grid,
  Container,
} from "@mui/material";

const Info = () => {
  return (
    <div className="text-center colorbase" style={{ paddingTop: 100 }}>
      <h2 className="text-lighting text-center mb-4">สื่อประชาสัมพันธ์</h2>
      <Container>
        <Grid
          container
          className="color-text justify-content-center"
          spacing={2}>
          <Grid item md={3}>
            <Card className="text-center">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset037.png"
                className="p-1 bg-body"
                width="100%"
              />
              <a
                href="https://youtu.be/sK1ZHdlDQ-E?si=Rw1xHL477RP5wpWq"
                target="_blank"                           // เปิดแท็บใหม่
                rel="noopener noreferrer"                 // เพื่อความปลอดภัย
                style={{ display: "block" }}
              >
                <img
                  src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset038.png"
                  className="p-1 bg-body"
                  width="100%"
                />
              </a>
            </Card>
          </Grid>
          <Grid item md={3}>
            <Card className="text-center">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset029.png"
                className="p-1 bg-body"
                width="100%"
              />
              <a
                  href="https://youtu.be/gc7ATmryDGE?si=Y0irzKKssslunA_M"
                target="_blank"                           // เปิดแท็บใหม่
                rel="noopener noreferrer"                 // เพื่อความปลอดภัย
                style={{ display: "block" }}
              >
                <img
                  src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset030.png"
                  className="p-1 bg-body"
                  width="100%"
                />
              </a>
            </Card>
          </Grid>
          <Grid item md={3}>
            <Card className="text-center">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset039.png"
                className="p-1 bg-body"
                width="100%"
              />
              <a
                  href="https://cfl.gpf.or.th/Files/Viewer/?fileName=e1ffa358-5e86-4ab4-9f2c-4740ce3e7dbc/Rootunpai-20.10.68.pdf"
                target="_blank"                           // เปิดแท็บใหม่
                rel="noopener noreferrer"                 // เพื่อความปลอดภัย
                style={{ display: "block" }}
              >
                <img
                  src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset040.png"
                  className="p-1 bg-body"
                  width="100%"
                />
              </a>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid
          container
          className="color-text justify-content-center"
          spacing={2}>
          <Grid item md={3}>
            <Card className="text-center">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset035.png"
                className="p-1 bg-body"
                width="100%"
              />
              <a
                href="https://cfl.gpf.or.th/Files/Viewer/?fileName=76afba5a-8968-4b10-85ef-546e4ef6dcb9/Compare-Pension.pdf"
                target="_blank"                           // เปิดแท็บใหม่
                rel="noopener noreferrer"                 // เพื่อความปลอดภัย
                style={{ display: "block" }}
              >
                <img
                  src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset036.png"
                  className="p-1 bg-body"
                  width="100%"
                />
              </a>
            </Card>
          </Grid>
          <Grid item md={3}>
            <Card className="text-center">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset031.png"
                className="p-1 bg-body"
                width="100%"
              />
              <a
                  href="https://cfl.gpf.or.th/Files/Viewer/?fileName=ac95fea1-4aab-4e30-9a42-52437f4bcfe2/Highlights-My-Digital-Twin.pdf"
                target="_blank"                           // เปิดแท็บใหม่
                rel="noopener noreferrer"                 // เพื่อความปลอดภัย
                style={{ display: "block" }}
              >
                <img
                  src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset032.png"
                  className="p-1 bg-body"
                  width="100%"
                />
              </a>
            </Card>
          </Grid>
          <Grid item md={3}>
            <Card className="text-center">
              <img
                src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset033.png"
                className="p-1 bg-body"
                width="100%"
              />
              <a
                  href="https://cfl.gpf.or.th/Files/Viewer/?fileName=c6baace2-0247-4832-83ba-2f57acb68673/New-Feature-My-Digital-Twin.pdf"
                target="_blank"                           // เปิดแท็บใหม่
                rel="noopener noreferrer"                 // เพื่อความปลอดภัย
                style={{ display: "block" }}
              >
                <img
                  src="https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page8/Asset034.png"
                  className="p-1 bg-body"
                  width="100%"
                />
              </a>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Info;
